import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import FormInput from '../FormInput';

function CompoundMultiplication({ name, references, constants, ...props }) {
    const {
        setValue,
        getValues,
        watch,
        formState: { dirtyFields },
    } = useFormContext();

    useEffect(() => {
        const calculateInitialValue = () => {
            const [initial, ...values] = getValues([...references]);
            if (constants) values.push(...constants);
            const result = values.reduce((prev, current) => parseFloat(prev) * (parseFloat(current) || 0), initial);
            setValue(name, parseFloat(result.toFixed(1)) || 0);
        };

        // Calculate the initial value of fat_weight when the component mounts
        calculateInitialValue();
    }, []); // Empty dependency array to run the effect only once on mount

    useEffect(() => {
        const calculateValue = () => {
            const [initial, ...values] = getValues([...references]);
            if (constants) values.push(...constants);
            const result = values.reduce((prev, current) => parseFloat(prev) * (parseFloat(current) || 0), initial);
            setValue(name, parseFloat(result.toFixed(1)) || 0, { shouldDirty: true });
        };

        // Recalculate when referenced fields change
        if (references.some((ref) => dirtyFields[ref])) {
            calculateValue();
        }
    }, [...watch([...references])]);

    return <FormInput name={name} {...props} />;
}

export default CompoundMultiplication;
